import {
  ComplaintById,
  objectLists,
  statusList,
} from "@modules/plaintes/plaintes.model.ts";
import React from "react";

interface ReferenceProps {
  complaint: ComplaintById;
}
const Reference: React.FC<ReferenceProps> = ({ complaint }) => {
  return (
    <>
      <div className="flex items-start lg:items-center lg:flex-row flex-col">
        <div className="ml-8 flex sm:flex-row flex-col">
          <p className="text-2xl font-semibold text-black">Référence:&nbsp;</p>
          <p className="text-2xl text-light-gray">{complaint.ref}</p>
        </div>
        {complaint.object && (
          <div className="flex sm:flex-row flex-col items-start sm:items-center ml-8 lg:ml-5">
            <p className="text-2xl font-semibold text-black">
              Objet de la plainte:&nbsp;
            </p>
            <p className="text-2xl text-light-gray">
              {objectLists.find((e) => e.code === complaint.object)?.name}
            </p>
          </div>
        )}
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-2 p-4">
        <div className="bg-gray-200 p-4 lg:mx-4 rounded-xl space-y-3 col-span-1">
          <div className="flex flex-wrap">
            <p className="font-semibold whitespace-nowrap">Date de plainte :&nbsp;</p>
            <p className="font-medium text-black break-words truncate max-w-full">
              {complaint.receivedDate as string}
            </p>
          </div>
          <div className="flex flex-wrap">
            <p className="font-semibold whitespace-nowrap">Région :&nbsp;</p>
            <p className="font-medium text-black break-words truncate max-w-full">
              {complaint.fokontany.municipality.district.region.name}
            </p>
          </div>
          <div className="flex flex-wrap">
            <p className="font-semibold whitespace-nowrap">District :&nbsp;</p>
            <p className="font-medium text-black break-words truncate max-w-full">
              {complaint.fokontany.municipality.district.name}
            </p>
          </div>
          <div className="flex flex-wrap">
            <p className="font-semibold whitespace-nowrap">Commune :&nbsp;</p>
            <p className="font-medium text-black break-words truncate max-w-full">
              {complaint.fokontany.municipality.name}
            </p>
          </div>
          <div className="flex">
            <p className="font-semibold">Village :&nbsp;</p>
            <p className="font-medium text-black">{complaint.fokontany.name}</p>
          </div>
        </div>
        <div className="lg:col-span-2 col-span-1 bg-gray-200 p-4 rounded-xl flex md:flex-row flex-col justify-between w-full">
          <div className="space-y-3 w-full md:w-[55%]">
            <div className="flex">
              <p className="font-semibold whitespace-nowrap">
                Nom du plaignant :&nbsp;
              </p>
              <p className="font-medium text-black">
                {complaint.complaintInfo.fullName.length > 0
                  ? complaint.complaintInfo.fullName
                  : "Plaignant anonyme"}
              </p>
            </div>
            <div className="flex">
              <p className="font-semibold">CNI du plaignant :&nbsp;</p>
              <p className="font-medium text-black">
                {complaint.complaintInfo.cinNumber}
              </p>
            </div>
            <div className="flex">
              <p className="font-semibold">Numéro téléphone :&nbsp;</p>
              <p className="font-medium text-black">
                {complaint.complaintInfo.phoneNumber}
              </p>
            </div>
            <div className="flex">
              <p className="font-semibold">ID menage :&nbsp;</p>
              <p className="font-medium text-black">
                {complaint.complaintInfo.householdId}
              </p>
            </div>
            <div className="flex">
              <p className="font-semibold">ID menage :&nbsp;</p>
              <p className="font-medium text-black">
                {complaint.complaintInfo.individualId}
              </p>
            </div>
          </div>

          <div className="space-y-3 w-full md:w-[35%]">
            <div className="flex">
              <p className="font-semibold whitespace-nowrap">Adresse :&nbsp;</p>
              <p className="font-medium text-black">
                {complaint.complaintInfo.address}
              </p>
            </div>
            <div className="flex">
              <p className="font-semibold">Handicapé(e) :&nbsp;</p>
              <p className="font-medium text-black">
                {complaint.complaintInfo.disabled === true ? "Oui" : "Non"}
              </p>
            </div>
            <div className="flex">
              <p className="font-semibold">Statut :&nbsp;</p>
              <p className="font-medium text-black">
                {
                  statusList.find((status) => status.code === complaint.status)
                    ?.name
                }
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="gap-5 px-4 lg:px-7 flex lg:flex-row flex-col w-full">
        <div className="lg:col-span-2 col-span-1 bg-gray-200 p-4 pl-5 rounded-xl w-full lg:w-1/2">
          <div className="space-y-3">
            <div className="flex">
              <p className="font-semibold">Réceptionneur : &nbsp;</p>
              <p className="font-medium text-black">
                {complaint.complaintUsers[0].user.firstName}{" "}
                {complaint.complaintUsers[0].user.lastName}
              </p>
            </div>
          </div>
        </div>
        <div className="lg:col-span-2 col-span-1 bg-gray-200 p-4 pl-5 rounded-xl w-full lg:w-1/2">
          <div className="space-y-3">
            <div className="flex">
              <p className="font-semibold">
                Détail sur le réceptionneur : &nbsp;
              </p>
              <p className="font-medium text-black">
                {complaint.complaintUsers[0].user.profil?.name!}
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Reference;
